<template>
  <div>
    <Echart
      :options="options"
      id="centreLeft1Chart"
      height="480px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
      // 定义颜色
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Array,
      default: () => ({}),
    },
    tabname: {
      type: Array,
      default: () => {
        return ["日", "周", "月"];
      },
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: this.tabname,
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: [
            {
              name: "",
              type: "bar",
              barWidth: "60%",
              itemStyle: {
                normal: {
                  color: function (params) {
                    var colorlist = ['#4f98df','#9ecf8e','feb041'];
                    return colorlist[params.dataIndex];
                  },
                },
              },
              data: newData,
              label: {
                show: true,
              },
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>